<template>
  <div v-loading="loading"
       class="vehicles-list">
    <el-table
      :data="vehicles"
      row-class-name="row-medium">
      <el-table-column
        prop="patent"
        label="Patente"
        min-width="90"/>
      <el-table-column
        prop="enterprise.name"
        label="Empresa"
        min-width="190"/>
      <el-table-column
        prop="distribution_center.name"
        label="CD"
        min-width="120"/>
      <el-table-column
        prop="active"
        label="Activo"
        width="70"
        :formatter="formatBool"/>
      <el-table-column
        prop="p2p_enabled"
        label="Wsp. ETA"
        :formatter="formatBool"/>
      <el-table-column
        prop="visible_points"
        label="Ptos."
        width="60"/>
      <el-table-column
        prop="insurance"
        label="Seguro"
        width="85"
        :formatter="formatDate"/>
      <el-table-column
        prop="max_insurance"
        label="Max. Asegurado"
        width="130"
        :formatter="formatMoney"/>
      <el-table-column
        prop="obligatory_insurance"
        width="130"
        label="Seg. Obligatorio"
        :formatter="formatDate"/>
      <el-table-column
        prop="certificate"
        label="Certificado"
        :formatter="formatDate"/>
      <el-table-column
        prop="technical_review"
        label="Rev. Técnica"
        width="100"
        :formatter="formatDate"/>
      <el-table-column
        prop="weight"
        label="Peso"
        :formatter="formatWeight"/>
      <el-table-column
        prop="height"
        label="Alto"
        :formatter="formatMeter"/>
      <el-table-column
        prop="width"
        label="Ancho"
        :formatter="formatMeter"/>
      <el-table-column
        prop="length"
        label="Largo"
        :formatter="formatMeter"/>
    </el-table>
    <div class="pagination">
      <el-pagination
        v-show="!loading"
        layout="sizes, total, prev, pager, next"
        :page-size="page.size"
        :page-sizes="page.sizes"
        :pager-count="5"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :total="page.totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { apiRequest } from '../../../backend/vue-axios/axios';

export default {
  name: 'VehicleList',
  data() {
    return {
      loading: true,
      vehicles: [],
      offset: 0,
      page: {
        size: 10,
        sizes: [10, 20, 30, 40, 50, 100],
        totalCount: 0,
      },
      params: {
        patent: '',
        active: [],
        p2p_enabled: [],
        enterprise_id: '',
        distribution_center_id: '',
      },
    };
  },
  mounted() {
    this.getVehicles();
  },
  methods: {
    getVehicles() {
      this.loading = true;
      const params = {
        limit: this.page.size,
        offset: this.offset,
      };
      Object.assign(params, this.params);
      params.active = this.params.active.length > 0 ? this.params.active[0] : '';
      params.p2p_enabled = this.params.p2p_enabled.length > 0 ? this.params.p2p_enabled[0] : '';
      apiRequest({
        module: 'transport',
        service: 'get_vehicles',
        params,
      }).then((response) => {
        this.vehicles = response.data;
        this.page.totalCount = parseInt(response.headers['x-total-count'], 10);
      }).catch((err) => {
        if (err.response.status === 404) {
          this.vehicles = [];
          this.$notify.warning({
            title: 'Sin resultados',
            message: err.response.data.message,
          });
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Error a cargar los datos',
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    formatDate(row, column, cellValue) {
      return moment.utc(cellValue).format('DD/MM/YY');
    },
    formatBool(row, column, cellValue) {
      return cellValue ? 'SI' : 'NO';
    },
    formatMoney(row, column, cellValue) {
      return `$ ${cellValue}`;
    },
    formatWeight(row, column, cellValue) {
      return `${cellValue} Kg`;
    },
    formatMeter(row, column, cellValue) {
      return `${cellValue.toFixed(1)} m`;
    },
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.page.size;
      this.getVehicles();
    },
    handleSizeChange(val) {
      this.offset = 0;
      this.page.totalCount = 0;
      this.page.size = val;
      this.getVehicles();
    },
    search(query) {
      this.params = query;
      this.offset = 0;
      this.page.totalCount = 0;
      this.getVehicles();
      /*
        this.$router.push({
          name: 'Status',
          query,
        });
       */
    },
  },
};
</script>

<style lang="scss" scoped>
  .vehicles-list {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 1px;
  }
</style>
